<template>
    <!-- 팝업 -->
    <div class="pop_up_layer find_account" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail" id="find_account" style="display: block">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <!-- 
        삭제 컨펌 모달
        -->
        <template v-if="state.tab === 1">
            <div class="pop_tit">
                <p v-text="state.title"></p>
            </div>
            <div class="content_wrap sign_form">
                <div class="result_wrap">
                    <p v-html="state.content"></p>
                </div>

                <div v-if="state.gubun === 4">
                    <ul style="margin-top: 20px">
                        <li>
                            <textarea id="textarea1" class="textarea" v-model="state.textarea1" placeholder="내용을 입력하세요 " />
                        </li>
                    </ul>
                </div>

                <div class="btn_wrap">
                    <button class="submit_btn _gray" @click="closeModal">취소</button>
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>

        <!-- 
        권한 요청 모달
        -->
        <template v-else-if="state.tab === 2">
            <div class="pop_tit">
                <p v-text="state.title"></p>
            </div>
            <div class="content_wrap sign_form">
                <ul style="margin-top: 20px">
                    <li>
                        <textarea id="textarea1" class="textarea" v-model="state.textarea1" placeholder="내용을 입력하세요 " />
                    </li>
                </ul>

                <div class="btn_wrap">
                    <button class="submit_btn _gray" @click="closeModal">취소</button>
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>

        <!-- 
        callback이 있는 alert용 모달
        -->
        <template v-else-if="state.tab === 3">
            <div class="pop_tit">
                <p v-text="state.title"></p>
            </div>
            <div class="content_wrap">
                <div class="result_wrap">
                    <p v-html="state.content"></p>
                </div>
                <div class="btn_wrap">
                    <!-- <button class="submit_btn _gray">취소</button> -->
                    <!-- <button class="submit_btn">예시</button> -->
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>

        <template v-else-if="state.tab === 4">
            <div class="pop_tit">
                <p v-text="state.title"></p>
            </div>
            <div class="content_wrap">
                <div class="result_wrap modal_image">
                    <img :src="state.content" alt="" />
                </div>
                <div class="btn_wrap">
                    <button class="submit_btn" @click="closeModal">확인</button>
                </div>
            </div>
        </template>

        <!-- 
        callback이 없는 alert용 모달 ( -1, 8 )
        -->
        <template v-else>
            <div class="pop_tit">
                <p v-text="state.title"></p>
            </div>
            <div class="content_wrap">
                <div class="result_wrap">
                    <p v-html="state.content"></p>
                </div>
                <div class="btn_wrap">
                    <!-- <button class="submit_btn _gray">취소</button> -->
                    <!-- <button class="submit_btn">예시</button> -->
                    <button class="submit_btn" @click="closeModal">확인</button>
                </div>
            </div>
        </template>
    </div>
    <!-- 팝업 -->
</template>
<script lang="ts" config>
    import { reactive, router, apiService, onMounted, onUnmounted, watch, computed, CommonUtils, ref } from "@/BaseComponent";

    export default {
        props: {
            type: {
                type: Number,
                default: 0,
            },
            title: {
                type: String,
                default: "",
            },

            content: {
                type: String,
                default: "",
            },

            gubun: {
                type: Number,
                default: 1,
            },
            idx: {
                type: Number,
                default: 0,
            },

            path: {
                type: String,
                default: "",
            },

            textarea1: {
                type: String,
                default: "",
            },
        },
        emits: ["close", "callback"],
        components: {},
        setup(props: any, { emit }: any) {
            const state = reactive({
                tab: -1 as number,

                title: "" as string,
                content: "" as string,
                gubun: 1 as 1 | 2 | 3 | 4, // 1: 수정, 2: 삭제
                path: "" as string,
                textarea1: "" as string,
                idx: 0 as number,
            });

            onMounted(() => {
                state.tab = props.type;
                state.title = props.title;
                state.content = props.content;
                state.textarea1 = props.textarea1;
                state.gubun = props.gubun;
                state.path = props.path;
                state.textarea1 = props.textarea1;
                state.idx = props.idx;

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.tab = props.type;
                state.title = props.title;
                state.content = props.content;
                state.gubun = props.gubun;
                state.path = props.path;
                state.textarea1 = props.textarea1;
                state.idx = props.idx;
            });

            const closeModal = () => {
                emit("close");
            };

            const callbackFun = () => {
                switch (state.tab) {
                    case 1:
                        // 컨펌 모달
                        {
                            const param: any = {};
                            param.action = "confirm";
                            if (state.gubun) param.gubun = state.gubun;
                            if (state.path) param.path = state.path;
                            if (state.idx > 0) param.idx = state.idx;
                            if (state.textarea1.length > 0) param.content = state.textarea1;
                            emit("callback", param);
                        }
                        break;
                    case 2:
                        // 권한 요청 모달
                        {
                            if (state.textarea1.length > 0) {
                                const param: any = {};
                                param.action = "requestAccess";
                                param.content = state.textarea1;
                                param.gubun = state.gubun;
                                emit("callback", param);
                            }
                        }
                        break;
                    case 3:
                        // callback이 있는 alert용 모달
                        {
                            const param: any = {};
                            param.action = "callback";
                            if (state.gubun) param.gubun = state.gubun;
                            if (state.path) param.path = state.path;
                            emit("callback", param);
                        }
                        break;
                    default:
                        {
                            const param: any = {};
                            param.action = "back";
                            param.path = state.path;
                            emit("callback", param);
                        }
                        break;
                }
            };

            return { state, closeModal, callbackFun };
        },
    };
</script>

<style scoped>
    .textarea {
        width: 100%;
    }
</style>
